import {
	TDef,
	Container,
	WrapperCell,
	StudentNameCell,
	StudentIdCell,
	StudentStateCell,
	StudentSanctionDateCell,
} from "./styles";
import { getDatePartsByMillis } from "components/CustomDatePicker/utils/helpers";

const ListItemSancionado = ({
	index,
	dataOfList,
	id,
	name,
	inscriptionDate,
	sanctionDate,
	isPinned,
}) => {
	const getDateInFormat = dateLong => {
		const dateInscriptionParts = getDatePartsByMillis(dateLong);
		return `${dateInscriptionParts[2]}/${dateInscriptionParts[1]+1}/${dateInscriptionParts[0]}`;
	}
	const getPositionRow = () => {
		const { index, length } = dataOfList;
		return index === 0 ? 1 : index === length - 1 ? -1 : 0;
	};
	const isOnlyOne = () => {
		return dataOfList.length === 1;
	};
	const getClassName = (positionCell = 1) => {
		const classList = [];
		const positionRow = getPositionRow();
		if (positionRow !== 0)
			classList.push(positionRow === 1 ? "first-row" : "last-row");
		if (positionCell !== 0)
			classList.push(positionCell === 1 ? "first-cell" : "last-cell");
		isPinned && classList.push("is-pinned");
		isOnlyOne() && classList.push("only-one");
		return classList.join(" ");
	};
	const studentIdClassName = getClassName(1),
		studentNameClassName = getClassName(0),
		studentSanctionDateClassName = getClassName(-1)
	return (
		<Container>
			<TDef>
				<StudentIdCell className={studentIdClassName}>
					<WrapperCell className={studentIdClassName}>
						<span>{id}</span>
					</WrapperCell>
				</StudentIdCell>
			</TDef>
			<TDef>
				<StudentNameCell className={studentNameClassName}>
					<WrapperCell className={studentNameClassName}>
						<span>{name}</span>
					</WrapperCell>
				</StudentNameCell>
			</TDef>
			<TDef>
				<StudentStateCell className={studentNameClassName}>
					<WrapperCell className={studentNameClassName}>
						<span>Sancionado</span>
					</WrapperCell>
				</StudentStateCell>
			</TDef>
			<TDef>
				<StudentStateCell className={studentNameClassName}>
					<WrapperCell className={studentNameClassName}>
						<span>{getDateInFormat(inscriptionDate)}</span>
					</WrapperCell>
				</StudentStateCell>
			</TDef>
			<TDef>
				<StudentSanctionDateCell className={studentSanctionDateClassName}>
					<WrapperCell className={studentSanctionDateClassName}>
						<span>{getDateInFormat(sanctionDate)}</span>
					</WrapperCell>
				</StudentSanctionDateCell>
			</TDef>
		</Container>
	);
};

export default ListItemSancionado;
